import Axios from '../lib/axios'
import store from '@/store'

class ArchivesService {
  async all (patientId, categoryId = null) {
    let params = {}
    if (categoryId != null) {
      params.categoryId = categoryId
    }
    const result = await Axios.authenticated().get(`/archives/${patientId}`, {params: params})
    return result
  }

  async create (archive) {
    let newArchive = JSON.parse(archive.get('archive'))
    let config = {
      onUploadProgress: e => store.state.currentProgress = Math.round(e.loaded * 100 / e.total),
      headers: {
        path: newArchive.patientId
      }
    }
    const result = await Axios.authenticated().post(
      `/archives/${newArchive.patientId}`,
      archive,
      config
    )
    return result
  }

  async delete (archive) {
    const result = await Axios.authenticated().delete(`/archives/${archive.patientId}`, { data: { id: archive._id } })
    return result
  }
}

export default new ArchivesService()
